//#region src/loves_sandbox_api_server.ts
var LovesSandboxApiServer = /* @__PURE__ */ function(LovesSandboxApiServer) {
	LovesSandboxApiServer["Dev"] = "dev";
	LovesSandboxApiServer["Qa"] = "qa";
	return LovesSandboxApiServer;
}(LovesSandboxApiServer || {});
//#endregion
export { LovesSandboxApiServer };

//# sourceMappingURL=loves_sandbox_api_server.js.map